export const CHECK_SALARY_INCOME_VALID = "checkSalaryIncomeValid";
export const SALARY_OCCUPATION_IS_VALID = "salaryOccupationIsValid";
export const STORE_SALARY_OCCUPATION = "storeSalaryOccupation";
